import { Helpers } from "./helpers/helpers";

export class SectionAnimations {
	constructor() {
		if (!Helpers.isEditScreen) {
			this.setSectionsInView();
		}

		this.expandableSection();
	}

	private setSectionsInView() {
		const items = document.querySelectorAll('.content-section');
		window.addEventListener("scroll",
			() => {
				items.forEach(item => {
					if (Helpers.elementIsInView(item as HTMLElement)) {
						item.classList.add('in-view');
					}
				});
			});
	}

	expandableSection(): void {
		document.querySelectorAll('.expand-toggle').forEach(toggle => {
			toggle.addEventListener('click',(e) => {
				const section = (e.target as HTMLElement).closest(".section-expandable");
				section.classList.toggle('expanded');
			});
		});
	}
}

